module.exports = __webpack_public_path__ + "loading-good.99b0185a4719fabfc0e26c1a1f8fec14.hashedasset.png";